import { HttpClient } from '@angular/common/http';
import { environment as config } from '../../../environments/environment';
import { Injectable } from '@angular/core';
import { AuthService } from '../auth/auth.service';

export interface IUploadStatus {
  name: string;
  uploadedAt: Date;
  uploadDuration: number;
  status: string;
  url: string;
  uploadedSize: number;
  fileSize: number;
}

export interface IDownloadStatus {
  vimeoScreencastDownloadUrl?: string;
  vimeoRecordingDownloadUrl?: string;
  vimeoScreencastStatus?: string;
  vimeoRecordingStatus?: string;
  liveeScreencastDownloadUrl?: string;
  liveeRecordingDownloadUrl?: string;
}

@Injectable()
export class VideoService {
  constructor(private http: HttpClient) {}

  private request(url: string) {
    return this.http.get(url, {
      headers: {
        Authorization: `Bearer ${AuthService.retrieve(AuthService.TOKEN_KEY)}`
      }
    });
  }

  getStatus(sessionId: string) {
    const url = `${config.screencastCustom.url}/status?sessionId=${sessionId}`;
    return this.request(url);
  }

  getDownloadStatus(sessionId: string) {
    const url = `${config.screencastCustom.url}/downloadStatus?sessionId=${sessionId}`;
    return this.request(url);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/sessions/video.service.ts